/* ag-v78e.js - AquaGrip CT (v78e, 27 Oct 2026, Claude)
   Spec rows become cards with an icon each, keyed by the row label.
   Touches no cart, no form and no studio code. */
(function(){
  'use strict';
  if(window.__agnSpecLoaded) return; window.__agnSpecLoaded = true;
  /* spec cards (v78e): an icon per row, keyed by its label */
  var SPEC_ICO = {
    price: '<path d="M3 12V4a1 1 0 0 1 1-1h8l9 9-9 9z"/><circle cx="7.5" cy="7.5" r="1.5"/>',
    foam:  '<path d="M12 3 2 8l10 5 10-5z"/><path d="m2 13 10 5 10-5"/><path d="m2 18 10 5 10-5" opacity=".55"/>',
    cut:   '<circle cx="12" cy="12" r="8"/><path d="M12 1v6M12 17v6M1 12h6M17 12h6"/>',
    size:  '<path d="M3 17 17 3l4 4L7 21z"/><path d="m7 13 2 2M10 10l2 2M13 7l2 2"/>',
    back:  '<rect x="3" y="4" width="18" height="12" rx="2"/><path d="M3 19h18"/><path d="m15 16 4 4" />',
    extra: '<path d="M12 3v18M3 12h18"/><circle cx="12" cy="12" r="9"/>',
    fits:  '<rect x="3" y="8" width="18" height="12" rx="2"/><path d="M3 12h18M8 8V5h8v3"/>',
    pocket:'<rect x="3" y="5" width="18" height="14" rx="2"/><path d="M9 5v14M15 5v14"/>',
    hole:  '<rect x="3" y="5" width="18" height="14" rx="2"/><circle cx="9" cy="12" r="3"/><circle cx="16.5" cy="12" r="1.8"/>',
    name:  '<path d="M4 7V5h16v2M12 5v14M9 19h6"/>',
    ruler: '<rect x="2" y="8" width="20" height="8" rx="1.5"/><path d="M6 8v3M10 8v4M14 8v3M18 8v4"/>'
  };
  function specKey(t){
    t = t.toLowerCase();
    if(/pric|small|short/.test(t)) return 'price';
    if(/fit/.test(t)) return 'fits';
    if(/size/.test(t)) return 'size';
    if(/ruler/.test(t)) return 'ruler';
    if(/cut-out|cutout/.test(t)) return 'hole';
    if(/pocket|tray/.test(t)) return 'pocket';
    if(/name|logo|graphic/.test(t)) return 'name';
    if(/foam|surface/.test(t)) return 'foam';
    if(/back/.test(t)) return 'back';
    if(/cut/.test(t)) return 'cut';
    return 'extra';
  }
  function specCards(){
    Array.prototype.forEach.call(document.querySelectorAll('.ag-spec .ag-spec-list > li'), function(li){
      if(li.querySelector('.agn-spec-head')) return;
      var k = li.querySelector('.k'); if(!k) return;
      var head = document.createElement('div'); head.className = 'agn-spec-head';
      head.innerHTML = '<span class="agn-spec-ico" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round">' + SPEC_ICO[specKey(k.textContent)] + '</svg></span>';
      li.insertBefore(head, k); head.appendChild(k);
    });
    Array.prototype.forEach.call(document.querySelectorAll('.ag-spec .ag-spec-list'), function(ul){
      if(ul.children.length % 2) ul.classList.add('agn-odd');
    });
  }

  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', specCards); else specCards();
})();
